import alert from "components/elements/Alert";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import session from "utils/session";

import { login, loginByAdmin } from "../services/loginApi";
import { setIsLoading, setIsLogin, setProfile } from "../slices/loginSlice";
import { message } from "antd";
import { useTranslation } from "react-i18next";

function useLogin() {
  const isLoading = useSelector((state) => state.login.isLoading);
  const isLogin = useSelector((state) => state.login.isLogin);
  const profile = useSelector((state) => state.login.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const doLogin = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        dispatch(setIsLogin(false));
        const modifyValues = {
          username: values.email,
          password: values.password,
        };
        const response = await login(modifyValues);
        const token = response.data?.token || null;
        session.setAuthToken(token);
        if (values.rememberMe === "Y") {
          window.localStorage.setItem("rememberUser", values.email);
        }
        dispatch(setProfile(response.data));
        dispatch(setIsLogin(true));
        message.success(t("common.login_success"))
        navigate("/");
      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, navigate]
  );

  const doLoginForAdminAccess = useCallback(
    async (values) => {
      try {
        dispatch(setIsLoading(true));
        dispatch(setIsLogin(false));
        const modifyValues = {
          username: values.email,
          password: values.password,
        };
        const response = await loginByAdmin(modifyValues);
        const token = response.data?.token || null;
        session.setAuthToken(token);
        if (values.rememberMe === "Y") {
          window.localStorage.setItem("rememberUser", values.email);
        }
        dispatch(setProfile(response.data));
        dispatch(setIsLogin(true));
        message.success(t("common.login_success"))

        if (response.data?.adminType == "SUPER_ADMIN"
          && response.data?.isAdminEndpoint == "Y") {
          navigate("/admin/response_company");
        }

      } catch (error) {
        message.error(t("common.error"))
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, navigate]
  );

  return { isLoading, isLogin, profile, doLogin, doLoginForAdminAccess };
}

export default useLogin;
